import { MiddlewareAPI } from 'redux';
import { ThunkDispatch } from 'store/store';
import State from 'store/State';
import { selectAppSettings } from 'app/store/appSettings/selectors';
import { loadCurrencies } from 'app/currencies/store/thunks';
import {
    AppSettingsActionType,
    UpdateAppSettingsAction,
} from 'app/store/appSettings/actions';

export const updateExchangeRateOnCurrencyChangedMiddleware =
    (
        middlewareAPI: MiddlewareAPI<
            ThunkDispatch<UpdateAppSettingsAction>,
            State
        >
    ) =>
    (next: ThunkDispatch<UpdateAppSettingsAction>) =>
    (action: UpdateAppSettingsAction) => {
        const previousState = middlewareAPI.getState();

        // update the state
        next(action);

        if (action.type !== AppSettingsActionType.UPDATE) {
            return;
        }

        const state = middlewareAPI.getState();

        const previousAppSettings = selectAppSettings(previousState);
        const nextAppSettings = selectAppSettings(state);

        if (previousAppSettings.currencyCode !== nextAppSettings.currencyCode) {
            middlewareAPI.dispatch(
                loadCurrencies([nextAppSettings.currencyCode])
            );
        }
    };
